import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesPermissionsSchemesEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-permissions-schemes-edit',
	path: '/secure/admin/EditPermissionScheme!default.jspa',
};
